export default __webpack_public_path__ + "static/1426-869e281bada2e2ab3ec72c85131a2540.gif";